import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import IntroSection from '../Common/IntroSection';
import AnimatedSection from '../Common/AnimatedSection';
import { InstagramEmbed } from 'react-social-media-embed';
import BlogDetail from './BlogDetail';
import BlogGrid from './BlogGrid';

const Blog = () => {
  useEffect(() => {
    // Enable smooth scrolling
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  const pageVariants = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        duration: 0.5,
        staggerChildren: 0.2
      }
    }
  };

  return (
    <motion.div 
      className="min-h-screen bg-gray-50"
      initial="initial"
      animate="animate"
      variants={pageVariants}
    >
      <AnimatedSection id="intro" delay={200}>
        <IntroSection 
          title="PRISTINE SMILE BLOG" 
          about="Dental health tips and resources for our patients"
        />
      </AnimatedSection>

      <AnimatedSection id="blogDetail" delay={200}>
        <BlogDetail />
      </AnimatedSection>

      <AnimatedSection id="blog" delay={400}>
        <BlogGrid />
      </AnimatedSection>
    </motion.div>
  );
};

export default Blog;